import React, {useState} from 'react';
import {IconButton, Tooltip} from '@mui/material';
import GroovyDialog from './GroovyDialog';
import CodeIcon from '@mui/icons-material/Code';
import {useHasPermission} from '../../permission/PermissionUtil';
import axios from "axios";
import {toast} from "react-toastify";

const squareHighlightStyle = {
    width: '45px',
    height: '45px',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0',
    padding: '0',
};

export default function ExecuteScriptButton() {

    const [showScriptExecuteDialog, setShowScriptExecuteDialog] = useState(false);

    const executeScript = async (script) => {
        setShowScriptExecuteDialog(false);
        await axios.post('/script/execute', script);
        toast.success("Script executed");
    };

    const hasExecuteScriptPermission = useHasPermission("Script:Execute");

    if (!hasExecuteScriptPermission) {
        return null;
    }

    return (
        <>
            {showScriptExecuteDialog && <GroovyDialog title="Execute Script" onApply={executeScript}
                                                      onClose={() => setShowScriptExecuteDialog(false)}/>}
            <IconButton
                size="large"
                type='button'
                onClick={() => setShowScriptExecuteDialog(true)}
                color="inherit"
                style={squareHighlightStyle}
            >
                <Tooltip title='Execute Script'>
                    <CodeIcon/>
                </Tooltip>
            </IconButton>
        </>
    );
}
